export const financeLifeAllSelector = (state) =>
  state?.financeLifeReducer?.financeLifeAll;
export const financeLifeOpenWithdrawSelector = (state) =>
  state?.financeLifeReducer?.financeLifeOpenWithdraw;
